export default __webpack_public_path__ + "static/media/Logo_VDI_teclab4_X1.2358a1b9.png";